import { render, staticRenderFns } from "./CommunicationEdit.vue?vue&type=template&id=edd44c70&"
import script from "./CommunicationEdit.vue?vue&type=script&lang=ts&"
export * from "./CommunicationEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edd44c70')) {
      api.createRecord('edd44c70', component.options)
    } else {
      api.reload('edd44c70', component.options)
    }
    module.hot.accept("./CommunicationEdit.vue?vue&type=template&id=edd44c70&", function () {
      api.rerender('edd44c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/communications/CommunicationEdit.vue"
export default component.exports